
import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Monitor, Smartphone } from "lucide-react";

type MobileAlertDialogProps = {
  isMobile: boolean;
};

export default function MobileAlertDialog({ isMobile }: MobileAlertDialogProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Only show on mobile devices
    if (isMobile) {
      // Check if the user has already dismissed the dialog
      const hasSeenMobileAlert = localStorage.getItem('hasSeenMobileAlert');
      if (!hasSeenMobileAlert) {
        setIsOpen(true);
      }
    }
  }, [isMobile]);

  const handleDismiss = () => {
    // Mark as seen in localStorage
    localStorage.setItem('hasSeenMobileAlert', 'true');
    setIsOpen(false);
  };

  // Only render the dialog if on a mobile device
  if (!isMobile) return null;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Smartphone className="h-5 w-5" /> Mobiel apparaat gedetecteerd
          </DialogTitle>
          <DialogDescription>
            Deze applicatie is nog niet volledig geoptimaliseerd voor mobiele apparaten
            en werkt het beste op een desktop of laptop.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          <div className="flex items-center justify-center gap-6">
            <div className="flex flex-col items-center">
              <Smartphone className="h-12 w-12 text-muted-foreground" />
              <span className="text-xs mt-1 text-muted-foreground">Beperkte functionaliteit</span>
            </div>
            <div className="flex flex-col items-center">
              <Monitor className="h-12 w-12 text-primary" />
              <span className="text-xs mt-1 text-primary font-medium">Aanbevolen</span>
            </div>
          </div>
          <p className="text-sm text-center text-muted-foreground">
            Voor de beste ervaring raden we aan om een desktop of laptop te gebruiken.
          </p>
        </div>
        <div className="flex justify-center">
          <Button onClick={handleDismiss}>
            Begrepen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
